import { render } from "./SkeletonItem.vue?vue&type=template&id=b655cad0&scoped=true"
import script from "./SkeletonItem.vue?vue&type=script&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&lang=js"

import "./SkeletonItem.vue?vue&type=style&index=0&id=b655cad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b655cad0"]])

export default __exports__